import React from 'react';

import { MINIMUM_NET_WORTH_TO_PROCEED } from '../../../constants';
import { FixedFeeNewContractStepOneData } from '../../../types';

interface UseStepOneProceedRulesProps {
  value: FixedFeeNewContractStepOneData;
  adjustedNetWorth?: number;
  loadingNetWorth: boolean;
  loadingAvailableRateRanges: boolean;
  isTermReplacementRestricted: boolean;
  isTermReplacementStatusLoading: boolean;
  onChange: (value: FixedFeeNewContractStepOneData) => void;
}

interface UseStepOneProceedRulesResult {
  hasNetWorthProblem: boolean;
  canProceed: boolean;
}

const shouldSkipNetWorthCheck = true;

export const useStepOneProceedRules = ({
  value,
  adjustedNetWorth,
  loadingNetWorth,
  loadingAvailableRateRanges,
  isTermReplacementRestricted,
  isTermReplacementStatusLoading,
  onChange,
}: UseStepOneProceedRulesProps): UseStepOneProceedRulesResult => {
  const hasNetWorthProblem =
    !shouldSkipNetWorthCheck &&
    !!value.selectedCustomer &&
    adjustedNetWorth !== undefined &&
    !loadingNetWorth &&
    adjustedNetWorth < MINIMUM_NET_WORTH_TO_PROCEED;

  const canProceed =
    !hasNetWorthProblem &&
    !loadingAvailableRateRanges &&
    !isTermReplacementStatusLoading &&
    !isTermReplacementRestricted;

  React.useEffect(() => {
    if (value.adjustedNetWorth === adjustedNetWorth && value.canProceed === canProceed) {
      return;
    }

    onChange({
      ...value,
      adjustedNetWorth,
      canProceed,
    });
  }, [adjustedNetWorth, canProceed, onChange, value]);

  return {
    hasNetWorthProblem,
    canProceed,
  };
};
